

import { BANKING_DETAILS_SET_VALUE } from "../../../actions/sizotsaFuneralCover/bankingDetails";
import { PURCHASE_PERSONAL_DETAILS_SET_VALUE } from "../../../actions/sizotsaFuneralCover/personalDetails";
import { QUOTE_DETAILS_FORM_SET_VALUE } from "../../../actions/sizotsaFuneralCover/quote";
import { UPLOAD_DOCUMENTS_SET_VALUE } from "../../../actions/sizotsaFuneralCover/uploadDocuments";
import { bankingDetailsValidations } from "./bankingDetails";
import { purchaseJourneyPersonalDetailsValidation } from "./personalDetails";
import { quoteDetailsValidation } from "./quoteDetails";
import { uploadDocumentsValidation } from "./uploadDocuments";

export const sizotsaFuneralCoverValidations = (store, next, action) => {

  if (action.type.startsWith(QUOTE_DETAILS_FORM_SET_VALUE)) {
    return quoteDetailsValidation(store, next, action);
  }
  if(action.type.startsWith(PURCHASE_PERSONAL_DETAILS_SET_VALUE)){
    return purchaseJourneyPersonalDetailsValidation(store, next, action)
  }
  if(action.type.startsWith(BANKING_DETAILS_SET_VALUE)){
    return bankingDetailsValidations(store, next, action)
  }
  if(action.type.startsWith(UPLOAD_DOCUMENTS_SET_VALUE)){
    return uploadDocumentsValidation(store, next, action)
  }
  return null;
};
